import component from '@/mixins/component'

export default {
  name: 'cover',
  mixins: [component],
  props: {
    image_mobile: {
      type: Object,
      default: () => {}
    },
    image_desktop: {
      type: Object,
      default: () => {}
    },
    color: {
      type: String,
      default: '#FF0000'
    }
  },
  data () {
    return {
      bgc: {
        backgroundColor: this.color
      }
    }
  }
}
